(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["santalumi-manta-es"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('santalumi-cozy')) {
  customElements.define('santalumi-cozy', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      this.cfg = JSON.parse(
        this.querySelector('[data-config]').textContent
      );

      this.prices = { 1: 3590, 2: 5385, 3: 7539 };
      this.selected = 2;
      this.busy = false;
      this.controller = new AbortController();

      const opts = { signal: this.controller.signal };
      this.sizes = ['S', 'M', 'L', 'XL', '2XL', '3XL'];

      const normal = value =>
        String(value).trim().toUpperCase().replace(/\s+/g, '');

      const sizeOf = variant => {
        const options = variant.options
          .map(normal)
          .map(value =>
            value === 'XXL'
              ? '2XL'
              : value === 'XXXL'
                ? '3XL'
                : value
          );

        return this.sizes.find(size => options.includes(size));
      };

      const candidates = this.cfg.variants.filter(variant =>
        variant.price === 3590 &&
        !variant.requiresSellingPlan &&
        sizeOf(variant)
      );

      const namedSingles = candidates.filter(variant =>
        variant.options.some(option => normal(option) === 'PACK1')
      );

      const singles = namedSingles.length ? namedSingles : candidates;

      this.bySize = new Map();
      this.ambiguous = false;

      this.sizes.forEach(size => {
        const matches = singles.filter(variant => sizeOf(variant) === size);

        if (matches.length === 1) {
          this.bySize.set(size, matches[0]);
        } else if (matches.length > 1) {
          this.ambiguous = true;
        }
      });

      this.querySelectorAll('[data-size-index]').forEach(select => {
        this.sizes.forEach(size => {
          const variant = this.bySize.get(size);
          const option = document.createElement('option');

          option.value = size;
          option.textContent = size + (!variant?.available ? ' · Agotada' : '');
          option.disabled = !variant?.available;

          select.append(option);
        });

        select.addEventListener(
          'change',
          () => this.select(this.selected),
          opts
        );
      });

      this.querySelectorAll('input[type=radio]').forEach(radio => {
        radio.addEventListener(
          'change',
          () => this.select(+radio.value),
          opts
        );
      });

      this.querySelectorAll('[data-thumb]').forEach(button => {
        button.addEventListener('click', () => {
          this.querySelector('[data-main]').src = button.dataset.thumb;

          this.querySelectorAll('[data-thumb]').forEach(item => {
            item.setAttribute('aria-pressed', String(item === button));
          });
        }, opts);
      });

      this.querySelectorAll('[data-add-button]').forEach(button => {
        button.addEventListener('click', () => this.add(), opts);
      });

      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;

      this.querySelector('.slc-motion').addEventListener('click', () => {
        this.paused = !this.paused;
        this.motion();
      }, opts);

      this.motion();

      this.reduced.addEventListener('change', event => {
        this.paused = event.matches;
        this.motion();
      }, opts);

      for (let i = 0; i < 22; i++) {
        const flake = document.createElement('span');
        flake.className = 'slc-flake';
        flake.textContent = i % 2 ? '❄' : '❅';
        flake.style.cssText = `
          left:${Math.random() * 100}%;
          font-size:${10 + Math.random() * 13}px;
          animation-duration:${11 + Math.random() * 14}s;
          animation-delay:-${Math.random() * 24}s
        `;
        this.querySelector('.slc-snow').append(flake);
      }

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);

      this.onScroll = () => {
        this.querySelector('.slc-sticky').classList.toggle(
          'visible',
          this.querySelector('.slc-hero').getBoundingClientRect().bottom < 0 &&
          this.getBoundingClientRect().bottom > 0
        );
      };

      window.addEventListener('scroll', this.onScroll, {
        passive: true,
        signal: this.controller.signal
      });

      this.onScroll();

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.paused) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: .35 });

      this.querySelectorAll('video').forEach(video => {
        this.observer.observe(video);
      });

      this.select(2);
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.querySelector('.slc-snow')?.replaceChildren();
      this.started = false;
    }

    money(amount) {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount / 100);
    }

    select(number) {
      const previous = this.selected;

      if (previous !== number) {
        const old = [
          ...this.querySelectorAll(`[data-sizes="${previous}"] select`)
        ];

        this.querySelectorAll(`[data-sizes="${number}"] select`)
          .forEach((element, index) => {
            if (!element.value && old[index]?.value) {
              element.value = old[index].value;
            }
          });
      }

      this.selected = number;

      this.querySelectorAll('[data-pack]').forEach(pack => {
        pack.classList.toggle(
          'is-selected',
          +pack.dataset.pack === number
        );
      });

      this.querySelectorAll('[data-sizes]').forEach(group => {
        group.hidden = +group.dataset.sizes !== number;
      });

      this.querySelector(
        `input[type=radio][value="${number}"]`
      ).checked = true;

      const selects = [
        ...this.querySelectorAll(`[data-sizes="${number}"] select`)
      ];

      this.chosen = selects.map(element => this.bySize.get(element.value));

      const configured =
        this.cfg.currency === 'EUR' &&
        this.cfg.productId &&
        !this.ambiguous &&
        this.bySize.size > 0;

      const sizesReady =
        this.chosen.length === number &&
        this.chosen.every(variant =>
          variant?.available && variant.price === 3590
        );

      this.ready = !!(
        configured &&
        (number === 1 || this.cfg.discountsReady) &&
        sizesReady
      );

      this.querySelector('[data-total]').textContent =
        this.money(this.prices[number]);

      this.querySelector('[data-sticky-price]').textContent =
        this.money(this.prices[number]);

      this.querySelector('[data-sticky-label]').textContent =
        number === 1
          ? '1 unidad · SantaLumi'
          : `Pack de ${number} · −${number === 2 ? 25 : 30}%`;

      this.querySelectorAll('[data-add-button]').forEach(button => {
        button.disabled =
          this.busy ||
          !configured ||
          (number > 1 && !this.cfg.discountsReady);

        button.textContent = this.busy
          ? 'AÑADIENDO…'
          : !configured || (number > 1 && !this.cfg.discountsReady)
            ? 'NO DISPONIBLE'
            : !sizesReady
              ? 'ELIGE LAS TALLAS →'
              : 'AÑADIR AL CARRITO →';
      });

      let message = '';

      if (!configured) {
        message = window.Shopify?.designMode
          ? 'Configura las variantes de talla S, M, L, XL, 2XL y 3XL a 35,90 €. Si conservas la opción Pack, usa Pack 1 para las unidades individuales. No debe haber dos variantes individuales de la misma talla.'
          : 'Producto no disponible en este momento.';
      } else if (number > 1 && !this.cfg.discountsReady) {
        message = window.Shopify?.designMode
          ? 'Crea los descuentos automáticos del 25% desde 2 unidades y del 30% desde 3. Después confirma su configuración en esta sección.'
          : 'Esta oferta no está disponible en este momento.';
      } else if (!sizesReady) {
        message = 'Elige la talla de cada manta para continuar.';
      }

      this.querySelector('[data-message]').textContent = message;
    }

    motion() {
      this.classList.toggle('is-paused', this.paused);

      const button = this.querySelector('.slc-motion');

      button.textContent = this.paused
        ? '▶ Activar animaciones'
        : 'Ⅱ Pausar animaciones';

      button.setAttribute('aria-pressed', String(this.paused));

      if (this.paused) {
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    }

    tick() {
      const now = new Date();
      let end = new Date(now.getFullYear() + '-12-25T00:00:00+01:00');

      if (end < now) {
        end.setFullYear(end.getFullYear() + 1);
      }

      const seconds = Math.floor((end - now) / 1000);

      this.querySelector('[data-count]').textContent =
        Math.floor(seconds / 86400) + ' d · ' +
        String(Math.floor(seconds / 3600) % 24).padStart(2, '0') + ' h · ' +
        String(Math.floor(seconds / 60) % 60).padStart(2, '0') + ' m · ' +
        String(seconds % 60).padStart(2, '0') + ' s';
    }

    async add() {
      if (this.busy) return;

      if (!this.ready) {
        const field = [
          ...this.querySelectorAll(
            `[data-sizes="${this.selected}"] select`
          )
        ].find(select => !select.value);

        if (field) {
          field.scrollIntoView({
            block: 'center',
            behavior: this.reduced.matches ? 'auto' : 'smooth'
          });
          field.focus();
        }

        return;
      }

      const number = this.selected;
      const counts = new Map();

      this.chosen.forEach(variant => {
        counts.set(variant.id, (counts.get(variant.id) || 0) + 1);
      });

      const items = [...counts].map(([id, quantity]) => ({
        id,
        quantity
      }));

      this.busy = true;
      this.select(number);

      this.querySelectorAll(
        'input[type=radio],[data-size-index]'
      ).forEach(element => {
        element.disabled = true;
      });

      let added = false;

      try {
        const response = await fetch(this.dataset.add, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            typeof data.description === 'string'
              ? data.description
              : 'No se ha podido añadir la selección. Comprueba las tallas y las cantidades disponibles.'
          );
        }

        added = true;

        const cartResponse = await fetch(this.dataset.cart + '.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });

        if (cartResponse.ok) {
          const cart = await cartResponse.json();

          const ids = new Set(
            [...this.bySize.values()].map(variant => variant.id)
          );

          const lines = cart.items.filter(item => ids.has(item.variant_id));

          const quantity = lines.reduce(
            (sum, item) => sum + item.quantity, 0
          );

          const base = lines.reduce(
            (sum, item) => sum + item.original_line_price, 0
          );

          const total = lines.reduce(
            (sum, item) => sum + item.final_line_price, 0
          );

          const rate = quantity >= 3 ? .7 : quantity >= 2 ? .75 : 1;

          if (
            quantity >= 2 &&
            total > Math.round(base * rate) + lines.length
          ) {
            const message = this.querySelector('[data-message]');

            message.textContent =
              'Las tallas ya están en tu carrito, pero no se ha confirmado el descuento esperado. Revisa el total antes de pagar. ';

            const link = document.createElement('a');
            link.href = this.dataset.cart;
            link.textContent = 'Revisar carrito';
            message.append(link);

            this.querySelectorAll('[data-add-button]').forEach(button => {
              button.disabled = true;
              button.textContent = 'AÑADIDO · REVISA EL CARRITO';
            });

            message.scrollIntoView({ block: 'center' });
            return;
          }
        }

        window.location.assign(this.dataset.cart);
      } catch (error) {
        const message = this.querySelector('[data-message]');

        message.textContent = (
          added
            ? 'Tu selección se ha añadido. Abre el carrito para comprobar el total.'
            : error instanceof TypeError
              ? 'No se pudo confirmar la conexión. Revisa el carrito antes de volver a intentarlo.'
              : error.message
        ) + ' ';

        const link = document.createElement('a');
        link.href = this.dataset.cart;
        link.textContent = 'Ver carrito';
        message.append(link);

        if (added || error instanceof TypeError) {
          this.querySelectorAll('[data-add-button]').forEach(button => {
            button.disabled = true;
            button.textContent = 'REVISA EL CARRITO';
          });
        } else {
          this.busy = false;

          this.querySelectorAll(
            'input[type=radio],[data-size-index]'
          ).forEach(element => {
            element.disabled = false;
          });

          this.querySelectorAll('[data-add-button]').forEach(button => {
            button.disabled = false;
            button.textContent = 'VOLVER A INTENTAR →';
          });
        }

        message.scrollIntoView({
          block: 'center',
          behavior: this.reduced.matches ? 'auto' : 'smooth'
        });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["santilumi-carrito-es"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('santilumi-cart-es'))customElements.define('santilumi-cart-es',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  if(!this.querySelector('[data-view]')){this.observer=new MutationObserver(()=>{if(this.querySelector('[data-view]')){this.observer.disconnect();this.connectedCallback();}});this.observer.observe(this,{childList:true,subtree:true});return;}
  this.ready=true;this.busy=false;this.failed=false;this.events=new AbortController();
  const on=(node,type,fn)=>node.addEventListener(type,fn,{signal:this.events.signal});
  on(this,'click',e=>{const remove=e.target.closest('[data-remove]'),step=e.target.closest('[data-step]');if(!remove&&!step)return;e.preventDefault();if(this.busy||this.failed)return;const row=e.target.closest('[data-key]'),input=row.querySelector('[data-quantity]');const quantity=remove?0:Math.max(0,Number(input.value)+Number(step.dataset.step));this.change(row.dataset.key,quantity);});
  on(this,'change',e=>{if(!e.target.matches('[data-quantity]'))return;const n=Number(e.target.value);if(!Number.isInteger(n)||n<0){e.target.value=e.target.defaultValue;return;}this.change(e.target.closest('[data-key]').dataset.key,n);});
  on(this,'submit',e=>{if(this.busy||this.failed){e.preventDefault();return;}if(e.submitter?.name!=='checkout'){e.preventDefault();const input=document.activeElement;if(input?.matches('[data-quantity]'))input.blur();}});
  on(window,'pageshow',e=>{if(e.persisted)window.location.reload();});
 }
 lock(on){this.busy=on;this.setAttribute('aria-busy',String(on));this.querySelectorAll('button,input').forEach(x=>x.disabled=on);}
 async change(key,quantity){
  if(this.busy||this.failed)return;this.lock(true);const status=this.querySelector('[data-status]');status.textContent='Actualizando tu carrito…';
  try{
   const response=await fetch(this.dataset.change,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:[this.dataset.section],sections_url:this.dataset.cart})});
   const data=await response.json();
   if(!response.ok)throw new Error('No se pudo actualizar la cantidad. Comprueba la disponibilidad y recarga el carrito.');
   const html=data.sections?.[this.dataset.section];
   if(!html){window.location.reload();return;}
   const doc=new DOMParser().parseFromString(html,'text/html');const fresh=doc.querySelector('santilumi-cart-es [data-view]');
   if(!fresh){window.location.reload();return;}
   this.querySelector('[data-view]').replaceChildren(...fresh.childNodes);this.lock(false);status.textContent='Carrito actualizado. El total ya está al día.';
  }catch(error){this.failed=true;this.busy=false;this.setAttribute('aria-busy','false');status.textContent='No hemos podido confirmar el total. Recarga el carrito antes de pagar. ';const link=document.createElement('a');link.href=this.dataset.cart;link.textContent='Recargar carrito →';status.append(link);}
 }
 disconnectedCallback(){this.events?.abort();this.observer?.disconnect();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["santilumi-cortina-es"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('santilumi-curtain-es')) {
  customElements.define('santilumi-curtain-es', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const configNode = this.querySelector('[data-sb-config]');
      if (!configNode) {
        this.parserObserver = new MutationObserver(() => {
          if (this.querySelector('[data-sb-config]')) {
            this.parserObserver.disconnect();
            this.connectedCallback();
          }
        });
        this.parserObserver.observe(this, { childList: true, subtree: true });
        return;
      }
      this.ready = true;
      this.events = new AbortController();
      const listen = (node, event, handler) => node.addEventListener(event, handler, { signal: this.events.signal });
      const config = JSON.parse(configNode.textContent);
      const cards = [...this.querySelectorAll('[data-pack]')];
      const button = this.querySelector('.ugx-cart');
      const message = this.querySelector('.ugx-msg');
      const sticky=this.querySelector('.lf-sticky');
      const stickyButton=this.querySelector('[data-sticky-add]');
      const stickyMessage=this.querySelector('[data-sticky-message]');
      const total = this.querySelector('.ugx-price strong');
      const money = cents => new Intl.NumberFormat('es-ES', { style: 'currency', currency: config.currency || 'EUR' }).format(cents / 100);
      let busy = false;
      const active = () => cards.find(card => card.querySelector('input[type="radio"]').checked);
      const choices = card => card ? [...card.querySelectorAll('select')].map(select => ({ id: select.value, option: select.selectedOptions[0] })) : [];
      const valid = card => Boolean(card) && choices(card).length === Number(card.dataset.pack) && choices(card).every(choice => choice.id && choice.option && !choice.option.disabled);
      const price = card => choices(card).reduce((sum, choice) => sum + Number(choice.option?.dataset.price || 0), 0);
      const offer = card => {
        if (!card || !config.promo) return null;
        const count = Number(card.dataset.pack);
        if (count < 2) return null;
        const code = config['code' + count];
        const percent = Number(config['discount' + count]);
        return code && percent > 0 ? { code, percent } : null;
      };
      const discount = card => {
        const promotion = offer(card);
        if (!promotion) return 0;
        const lines = new Map();
        choices(card).forEach(choice => lines.set(choice.id, (lines.get(choice.id) || 0) + Number(choice.option?.dataset.price || 0)));
        return [...lines.values()].reduce((sum, amount) => sum + Math.round(amount * promotion.percent / 100), 0);
      };
      const payable = card => price(card) - discount(card);
      const update = () => {
        const selected = active();
        cards.forEach(card => {
          const on = card === selected;
          card.classList.toggle('is-active', on);
          card.querySelector('[data-fields]').hidden = !on;
          card.querySelector('input[type="radio"]').disabled = busy;
          card.querySelectorAll('select').forEach(select => { select.disabled = !on || busy; });
          card.querySelector('[data-pack-total]').textContent = valid(card) ? money(payable(card)) : 'No disponible';
          const savings = card.querySelector('[data-savings]');
          const amount = discount(card);
          savings.hidden = !valid(card) || amount <= 0;
          savings.textContent = amount > 0 ? '−' + offer(card).percent + ' % · Ahorras ' + money(amount) + ' frente a comprar por separado · aprox. ' + money(Math.round(payable(card) / Number(card.dataset.pack))) + ' por cortina' : '';
        });
        total.textContent = valid(selected) ? money(payable(selected)) : 'Elige una medida disponible';
        const giftBox = this.querySelector('[data-door-gift]');
        if (giftBox) giftBox.hidden = Number(selected?.dataset.pack || 1) < 2;
        button.disabled = busy || !valid(selected);
        button.textContent = busy ? 'AÑADIENDO…' : valid(selected) ? 'AÑADIR AL CARRITO →' : 'NO DISPONIBLE';
        if(stickyButton){stickyButton.disabled=button.disabled;stickyButton.textContent=busy?'Añadiendo…':valid(selected)?'Añadir al carrito':'No disponible';this.querySelector('[data-sticky-price]').textContent=valid(selected)?money(payable(selected)):'—';this.querySelector('[data-sticky-selection]').textContent=(selected?.dataset.pack||1)+' cortina(s) · Cambiar';}
      };
      if(stickyButton) listen(stickyButton,'click',()=>button.click());
      if(stickyMessage){this.messageObserver=new MutationObserver(()=>{stickyMessage.replaceChildren(...[...message.childNodes].map(n=>n.cloneNode(true)));});this.messageObserver.observe(message,{childList:true,subtree:true,characterData:true});}
      cards.forEach(card => listen(card, 'change', () => { message.textContent = ''; update(); }));
      this.querySelectorAll('.ugx-thumbs button').forEach((thumb, index) => {
        thumb.setAttribute('aria-pressed', String(index === 0));
        listen(thumb, 'click', () => {
          const image = this.querySelector('.ugx-primary img');
          image.removeAttribute('srcset');
          image.src = thumb.dataset.src;
          image.alt = thumb.querySelector('img').alt;
          this.querySelectorAll('.ugx-thumbs button').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
        });
      });
      listen(button, 'click', async () => {
        if (busy || !valid(active())) return;
        const selected = active();
        const count = Number(selected.dataset.pack);
        const selectedOffer = offer(selected);
        const grouped = new Map();
        choices(selected).forEach(choice => grouped.set(choice.id, (grouped.get(choice.id) || 0) + 1));
        const items = [...grouped].map(([id, quantity]) => ({ id: Number(id), quantity }));
        busy = true;
        update();
        message.textContent = 'Estamos preparando tu pack navideño…';
        let sent = false;
        try {
          if (config.gift && count >= 2) {
            const check = await fetch(config.gift.url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
            if (!check.ok) throw new Error('No podemos comprobar el regalo ahora. Inténtalo más tarde.');
            const giftProduct = await check.json();
            const gift = giftProduct.variants.find(item => String(item.id) === String(config.gift.id));
            if (!gift || !gift.available || Number(gift.price) !== 0) throw new Error('El regalo no está disponible en este momento. Actualiza la página.');
            items.push({ id: config.gift.id, quantity: 1, properties: { Regalo: 'Regalo del pack navideño' } });
          }
          sent = true;
          const response = await fetch(config.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) {
            if (response.status === 422) throw new Error('No hay unidades suficientes de una medida. Elige otra medida o un pack más pequeño.');
            throw new Error('No hemos podido añadir el pack. Comprueba tu carrito.');
          }
          if (config.preview) {
            message.textContent = 'Vista previa: pack comprobado. No se ha realizado ningún pedido.';
            this.dispatchEvent(new CustomEvent('slce:preview-add', { detail: { items, code: selectedOffer?.code || null } }));
            busy = false; update(); return;
          }
          window.location.assign(selectedOffer ? '/discount/' + encodeURIComponent(selectedOffer.code) + '?redirect=' + encodeURIComponent(config.cartUrl) : config.cartUrl);
        } catch (error) {
          message.textContent = error instanceof TypeError ? 'Se ha interrumpido la conexión. Comprueba tu carrito antes de volver a intentarlo.' : error.message || 'Vuelve a intentarlo más tarde.';
          if (sent) {
            const link = document.createElement('a');
            link.href = config.cartUrl;
            link.textContent = ' Ver el carrito →';
            message.append(link);
          }
          busy = false;
          update();
        }
      });
      update();
      const pause = this.querySelector('.sl-motion');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) this.classList.add('sl-paused');
      const pauseLabel = () => {
        const paused = this.classList.contains('sl-paused');
        pause.textContent = paused ? '▷ Activar animaciones' : 'Ⅱ Pausar animaciones';
        pause.setAttribute('aria-pressed', String(paused));
      };
      pauseLabel();
      listen(pause, 'click', () => { this.classList.toggle('sl-paused'); pauseLabel(); });
      const snow = this.querySelector('.ugx-snow');
      snow.replaceChildren();
      if (!reduced) {
        for (let j = 0; j < (innerWidth < 700 ? 24 : 40); j++) {
          const flake = document.createElement('span');
          flake.className = 'ugx-flake'; flake.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M3.34 7l17.32 10M3.34 17L20.66 7M9 4l3 3 3-3M9 20l3-3 3 3M3.6 10.5l4.1-1.1-1.1-4.1M17.4 18.7l-1.1-4.1 4.1-1.1M3.6 13.5l4.1 1.1-1.1 4.1M17.4 5.3l-1.1 4.1 4.1 1.1"/></g></svg>';
          flake.style.left = (j * 71.37 % 100) + '%';
          flake.style.fontSize = (12 + j % 11) + 'px';
          flake.style.animationDuration = (9 + j % 14) + 's';
          flake.style.animationDelay = (-(j * 2.3) % 22) + 's';
          flake.style.setProperty('--ugx-fall-distance', (innerHeight + 80) + 'px');
          snow.append(flake);
        }
      }
      const clock = this.querySelector('[data-sb-countdown]');
      if (clock) {
        const target = Date.parse(clock.dataset.deadline);
        const output = clock.querySelector('[data-sb-time]');
        output.innerHTML=['DÍAS','H','MIN','S'].map(label=>'<span><b>00</b><small>'+label+'</small></span>').join('');
        const digits=[...output.querySelectorAll('b')];
        const tick = () => {
          const seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
          if (!Number.isFinite(target) || seconds <= 0) { clock.hidden = true; clearInterval(this.timer); return; }
          [Math.floor(seconds/86400),Math.floor(seconds%86400/3600),Math.floor(seconds%3600/60),seconds%60].forEach((v,i)=>{digits[i].textContent=String(v).padStart(2,'0');});
        };
        tick();
        listen(document,'visibilitychange',()=>{if(!document.hidden)tick();});
        listen(window,'pageshow',tick);
        if (Number.isFinite(target) && target > Date.now()) this.timer = setInterval(tick, 1000);
      }
      if ('IntersectionObserver' in window && !reduced) {
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('lf-visible');this.revealObserver.unobserve(entry.target);}}),{threshold:0.08});
        this.querySelectorAll('.ugx-stepgrid article,.ugx-v5-photo,.lf-confidence-grid article,.ugx-v5-editorial').forEach(el=>{el.classList.add('lf-reveal');this.revealObserver.observe(el);});
      }
      const hero=this.querySelector('.ugx-hero');
      const syncSticky=()=>{
        if(!sticky)return;
        const rect=button.getBoundingClientRect();
        const mainVisible=rect.top>=0 && rect.bottom<=innerHeight;
        sticky.hidden=hero.getBoundingClientRect().top > -140;
      };
      if('IntersectionObserver' in window){this.buyObserver=new IntersectionObserver(syncSticky,{threshold:[0,1]});this.buyObserver.observe(hero);this.buyObserver.observe(button);}
      listen(window,'scroll',syncSticky);
      listen(window,'resize',syncSticky);
      syncSticky();
      const refreshCount = async () => {
        if (config.preview) return;
        try {
          const response = await fetch(config.rootUrl + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          const badge = this.querySelector('[data-cart-count]');
          badge.textContent = String(cart.item_count); badge.hidden = cart.item_count === 0;
        } catch (_) {}
      };
      listen(window, 'pageshow', refreshCount);
      listen(document, 'visibilitychange', () => { if (!document.hidden) refreshCount(); });
    }
    disconnectedCallback() {
      this.parserObserver?.disconnect();
      this.events?.abort();
      this.messageObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.buyObserver?.disconnect();
      clearInterval(this.timer);
      this.ready = false;
    }
  });
}



  } catch(e) { console.error(e); }
})();
})();
